import React, { useEffect } from "react";
import NavBar from "../component/NavBar";
import styled from "styled-components";
import {
  H1label,
  Paragraphlabel,
  RadioProceed,
} from "../component/component.style";
import Footer from "../component/Footer";
import { useHistory } from "react-router-dom";
import { useQuestion } from "../utils/question";
import { getEnquiryId } from "../utils/enquiry";
import {
  FullPageLoader,
  useRecommendation,
} from "../contexts/recommendation-context";
import { useMutation } from "react-query";
import * as mq from "../styles/mediaQueries";
import { useFromFyntune } from "../utils";

function RecommendationPage() {
  const fromFyntune = useFromFyntune();
  const history = useHistory();
  const { setAnswers } = useRecommendation();
  const { firstQuestion } = useQuestion();
  const { tab, sequence } = firstQuestion;

  const { data, status, isError, mutate } = useMutation(() => getEnquiryId);

  useEffect(() => {
    mutate();
  }, [mutate]);

  if (isError) return <p>An error occured while generating enquiry Id</p>;

  if (["loading", "idle"].includes(status)) return <FullPageLoader />;

  const { enquiry_id } = data;

  const handleProceedClick = () => {
    !fromFyntune && setAnswers({});
    history.push(`/question/${enquiry_id}/${tab}/${sequence}`);
  };

  return (
    <div>
      <NavBar />
      <Container>
        <Section>
          <H1label>
            Let's understand how much life insurance cover you need.
          </H1label>
          <Paragraphlabel>It takes only 5 minutes. Ready to go?</Paragraphlabel>
          <div style={{ marginTop: "35px" }}>
            <RadioProceed onClick={handleProceedClick}>Let's Go</RadioProceed>
          </div>
        </Section>
      </Container>
      <Footer />
    </div>
  );
}

export default RecommendationPage;

const Section = styled.div`
  margin-top: 8.12em;
  padding: 1.25em 3.12em;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;

  ${mq.sm} {
    padding: 20px 0;
  }
`;

const Container = styled.main`
  max-width: 75em;
  width: 90%;
  margin: auto;
`;
